/**
 * @Author:
 * @Description:
 * @DateTime: Created in 16:53 2020/10/16
 */
import Vue from 'vue'
import Vuex from 'vuex'

import layout from './modules/layout'
import stationDetail from './modules/stationDetail'

Vue.use(Vuex)

const store = new Vuex.Store({
	modules: {
        layout,
        stationDetail
	},
})

export default store
